import React from 'react';
import { Checkbox, Groupper, Button, Message } from 'react-frontier';
import { SetLoading } from '../SiteClasses';
import { partition } from '../SiteUtil';
import UserAccess from '../UserAccess';

interface UserAccessConfigProps{
	accesss: number[],
	onAccessChange: (acc: number[])=>void,
	style?: React.CSSProperties,
	width?: number,
	onClick?: (setLoading: SetLoading)=>void,
	errorPrompts?: string[],
}

var UserAccessConfig = (props: UserAccessConfigProps)=>{
	var isCategoryChecked = (category_id: number)=>{
		var cat = UserAccess.ACCESS_ARRAY.find(a=>a.id==category_id);
		if(!cat || cat.access.length==0) return false;
		return cat.access.every(a=>props.accesss.indexOf(a.id)!=-1);
	}

	var onCategoryChecked = (category_id: number)=>{
		return (checked: boolean)=>{
			var cat = UserAccess.ACCESS_ARRAY.find(a=>a.id==category_id);
			if(!cat || cat.access.length==0) return;
			var cat_acc = cat.access.map(a=>a.id);
			var new_acc = [...props.accesss];
			if(checked){
				for(var i of cat_acc){
					if(new_acc.indexOf(i)==-1) new_acc.push(i);
				}
			}else{
				new_acc = new_acc.filter(a=>cat_acc.indexOf(a)==-1);
			}
			props.onAccessChange(new_acc);
		}
	}

	var onAccessChange = (access: number)=>{
		return (checked: boolean)=>{
			if(props.accesss.indexOf(access)==-1){
				if(!checked) return;
				props.onAccessChange([...props.accesss, access]);
			}else{
				if(checked) return;
				props.onAccessChange(props.accesss.filter(a=>a!==access));
			}
		}
	}

	return <Groupper className="ar user-access-config" style={{ width: props.width, ...props.style }} title='Permisos' actions={<Button text='Guardar' color='black' size='small' onClick={props.onClick} />}>
		{UserAccess.ACCESS_ARRAY.map((a, index)=>(
			<React.Fragment key={`USR-ACC-CFG-${a.id}`}>
				<div className={`category${index===0 ? ' first' : ''}`}>
					<Checkbox
						checked={isCategoryChecked(a.id)}
						onChange={onCategoryChecked(a.id)}
						label={<span className="cat-name">{a.name}</span>}
					/>
				</div>
				<table className="access" style={{ width: '100%' }}>
					<tbody>
						{partition(a.access, 2).map((b, i)=>(
							<tr key={`USR-ACC-TR-${a.id}-${i}`}>
								{b.map(acc=>(
									<td style={{ width: '50%' }} key={`USR-ACC-TD-${acc.id}`}>
										<Checkbox
											checked={props.accesss.indexOf(acc.id)!=-1}
											color='blue'
											label={<span><span className="acc-id">[{acc.id}]</span> {acc.name}</span>}
											onChange={onAccessChange(acc.id)}
										/>
									</td>
								))}
							</tr>
						))}
					</tbody>
				</table>
			</React.Fragment>
		))}
		<Message type="error" list={props.errorPrompts} size='small' />
	</Groupper>
}

export default UserAccessConfig;
